export default function ($scope, getUsers, currentUser) {
    $scope.errorsOccured = false;
    $scope.users = null;
    $scope.currentUser = null;
    $scope.isFetchingRecords = false;
    $scope.noRecords = false;
    $scope.hasMoreData = true;
    $scope.pageNumber = 0;
    
    currentUser()
        .then(result => {
            $scope.currentUser = result;
        });

    $scope.canGoToNextPage = function () {
        return $scope.hasMoreData;
    };

    $scope.loadNextPage = function () {
        if ($scope.hasMoreData) {
            $scope.requestUsers($scope.pageNumber + 1);
        }
    };

    $scope.canGoToPreviousPage = function () {
        return $scope.pageNumber > 1;
    };

    $scope.loadPreviousPage = function () {
        if ($scope.pageNumber === 1) {
            return;
        }
        $scope.requestUsers($scope.pageNumber - 1);
    };

    $scope.requestUsers = function (pageNumber) {
        $scope.pageNumber = pageNumber;
        $scope.isFetchingRecords = true;

        getUsers(pageNumber)
            .then(data => {
                // prevent paging jump if request don't resolve in order
                if ($scope.pageNumber !== pageNumber) {
                    return;
                }

                $scope.isFetchingRecords = false;
                $scope.users = data.users;
                $scope.hasMoreData = data.hasMoreData;

                $scope.noRecords = $scope.users.length === 0;
            })
            .catch(() => {
                $scope.isFetchingRecords = true;
                $scope.errorsOccured = true;
            });
    };

    $scope.loadNextPage();
}



// WEBPACK FOOTER //
// ./Client/app/admin/users/controllers/list/userlistCtrl.js